import { Injectable, inject } from "@angular/core";
import { ToastService } from "root/shared/services/toast-service/toast.service";
import { firstValueFrom } from "rxjs";
import { ToastType } from "root/shared/services/toast-service/toast.enum";
import { DocumotoFetchMediaContentJob, DocumotoMediaSyncJob, DocumotoProcessBillOfMaterialContentJob, DownloadManualJob, ProcessManualPackageJob } from 'root/mibp-openapi-gen/models';
import { operationsFnTerminateRunningJob } from "root/mibp-openapi-gen/fn/operations/operations-fn-terminate-running-job";
import { MibpApiService } from "root/mibp-openapi-gen/mibp-api.service";

export interface TerminateJobResult {
  wasTerminated: boolean;
}

type JobType =  'DocumotoPollForMediaChangesJob' |
                'DocumotoMediaSyncJob' |
                'DocumotoFetchMediaContentJob' |
                'DownloadManualJob' |
                'DocumotoProcessBillOfMaterialContentJob' |
                'ProcessManualPackageJob' |
                'DocumotoPropagateMediaAccessJob';

@Injectable({
  providedIn: 'root'
})
export class MibpJobsService {
    private mibpApiService = inject(MibpApiService);
  private toast = inject(ToastService);


  constructor() {}

  public async terminateJob(databaseEntityName: JobType, id: number): Promise<TerminateJobResult> {

    try {

      const result = await firstValueFrom(this.mibpApiService.invoke(operationsFnTerminateRunningJob, {
                  databaseEntityTypeName: databaseEntityName,
                  jobId: id
                }));

      if (result.notImplemented) {
        this.toast.showTextWithTitle(`Termination of type ${databaseEntityName} is not implemented`, 'Not implemented');
        return;
      }

      const messages = [
        result.databaseUpdatedSuccessfully ? 'Database updated' : null,
        result.databaseWasUpdated && !result.databaseUpdatedSuccessfully ? 'Could not update database' : null,
        result.terminateUrlWasCalled ? 'Terminate URL was invoked' : null
      ].filter(Boolean);

      this.toast.showText(messages.join('<br>'), {
        isHtml: true,
        type: ToastType.Info
      });


      return {
        wasTerminated: result.databaseUpdatedSuccessfully || result.terminateUrlWasCalled
      };

    } catch (e) {

      this.toast.showTextWithTitle('Could not terminate job', 'Error', {type: ToastType.Error});

      return {
        wasTerminated: false
      };
    }

  }


}
